import { useIonViewWillLeave, IonNote, IonImg, IonRefresher, IonRefresherContent, useIonRouter, IonList, IonAlert, IonGrid, IonRow, IonCol, IonCardTitle, IonCardSubtitle, IonCardHeader, IonCardContent, IonAvatar, IonToast, useIonViewWillEnter, IonIcon, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { Component, useState }  from 'react';
import { RouteComponentProps } from "react-router-dom";
import { heart } from "ionicons/icons";


import './Main.css';

import { showTab, hideTab } from "../components/Tabs";
import { LANGUAGE, GetStr } from "../language/Language";
import { Storage } from '@capacitor/storage';   
import NServer, { UIElement, handleRouteError, RegisterAppServices } from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';


const Live : React.FC = () => {

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        hideTab();

        RegisterAppServices();
    });

    useIonViewWillLeave(() => {
        showTab();
    });

    const getData = async () => {
        
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

        /*
		var server = new NServer();
        await server.getList("games", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // update the UI
            setNewApps(server.data.new);

            setHighlightApps(server.data.highlight);

            setAllApps(server.data.all);
        }
        */
	}

    const doRefresh = async (ev : any) => {
        await getData();

        ev.detail.complete();
    };

    return (
       <IonPage>
            <IonContent fullscreen>
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/mainc" ></IonBackButton>
                    </IonButtons>
                </IonToolbar>
                Going live!!
            </IonContent>
        </IonPage>
  );
};

export default Live;
